// import { bootstrap } from '@angular/platform-browser-dynamic';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import {enableProdMode} from '@angular/core';
import {Config} from './config';
// import {HTTP_PROVIDERS, JSONP_PROVIDERS } from '@angular/http';
// import {TRANSLATE_PROVIDERS, TranslateService, TranslatePipe, TranslateLoader, TranslateStaticLoader} from 'ng2-translate/ng2-translate';


// import { AppComponent } from './app.component';

/**This portion below only works when working with Webpack. For SystemJS, comment the following lines**/
// import 'material-design-lite/dist/material.min.css';
// import 'mdl-selectfield/dist/mdl-selectfield.min.css';
// import '../css/styles.css';
// if (process.env.ENV === 'production') {
    enableProdMode();
// }


// This is to use dojo/request/xhr from ArcGIS JS API library (theoretically compatible with all browsers)
define(["dojo/request/xhr"], function(xhr){
    xhr("data/settings.json", {
        handleAs: "json"
    }).then(function(data){
        // Do something with the handled data
        Config.config = data;
        platformBrowserDynamic().bootstrapModule(AppModule);
    }, function(err){
        // Handle the error condition
        console.log(err);
    }, function(evt){
        // Handle a progress event from the request if the
        // browser supports XHR2
    });
});
// bootstrap(AppComponent, [HTTP_PROVIDERS, JSONP_PROVIDERS, TRANSLATE_PROVIDERS]).catch(err => console.error(err));


// WEBPACK FOOTER //
// ./app/main.ts